import { constants } from 'stores/ExperienceFilterStore';

export default {
  experiencefilter: {
    setGuests(guests) {
      this.dispatch(constants.SET_GUESTS, guests);
    },
    setDateTime({ date, time }) {
      this.dispatch(constants.SET_DATE_TIME, { date, time });
    },
    setDate({ date }) {
      this.dispatch(constants.SET_DATE, { date });
    },
    setTime({ time }) {
      this.dispatch(constants.SET_TIME, { time });
    },
    setLanguages({ languages }) {
      this.dispatch(constants.TOGGLE_LANGUAGE, { languages });
    },
    setSelectedHost({ host }) {
      this.dispatch(constants.SET_SELECTED_HOST, { host });
    },
    resetStore() {
      this.dispatch(constants.RESET_STORE);
    },
  },
};
